import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import {
  EEntityType,
  ERelationType,
  ICorporateDesign,
  IDirectTicket,
  TariffProductDefinition,
  TariffProductGroup,
  TariffSelectionAttribute,
} from '@web/dtos';
import { SectionComponent } from '../../../../components/layout/section/section.component';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LoadingAnimationComponent } from '../../../../components/feedback/loading-animation/loading-animation.component';
import { Router } from '@angular/router';
import {
  EPage,
  DirectTicketConfigurationShoppingCartComponent,
} from '../../../../components/feedback/direct-ticket-configuration-shopping-cart/direct-ticket-configuration-shopping-cart.component';
import {
  IProductInCart,
  ShoppingCartService,
} from '../../../../services/shopping-cart/shopping-cart.service';
import { TicketOptionsFormComponent } from '../../../../components/data-input/ticket-options-form/ticket-options-form.component';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { ITicketDefinitionForm } from '../../../../services/shopping-cart/shopping-cart-form.service';
import { ERoute } from '../../../../constants/routes.enum';
import { OrderDirectTicketSupportService } from '../../../../services/support/order-ticket-support/order-direct-ticket-support.service';

@Component({
  selector: 'aw-direct-ticket-option-configuration-page',
  imports: [
    SectionComponent,
    ReactiveFormsModule,
    LoadingAnimationComponent,
    DirectTicketConfigurationShoppingCartComponent,
    TicketOptionsFormComponent,
  ],
  templateUrl: './direct-ticket-option-configuration-page.component.html',
})
export class DirectTicketOptionConfigurationPage {
  public readonly ticketName: InputSignal<string> = input.required();

  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly shoppingCartService: ShoppingCartService =
    inject(ShoppingCartService);
  private readonly directTicketOrderService: OrderDirectTicketSupportService =
    inject(OrderDirectTicketSupportService);
  private readonly router: Router = inject(Router);

  public readonly corporateDesign: Signal<ICorporateDesign> =
    this.corporateDesignService.corporateDesign;
  public readonly ticketConfiguration: Signal<TariffProductGroup> = this
    .shoppingCartService
    .directTicketConfiguration as Signal<TariffProductGroup>;
  public readonly isLoading: Signal<boolean> =
    this.shoppingCartService.isLoadingTicketConfiguration;

  protected readonly productForms: FormArray<FormGroup<ITicketDefinitionForm>> =
    this.shoppingCartService.productForms;
  protected readonly currentProductDefinition: Signal<
    TariffProductDefinition | undefined
  > = this.shoppingCartService.currentProductDefinition;
  protected readonly ticketsInCart: Signal<IProductInCart[]> =
    this.shoppingCartService.ticketsInCart;

  protected readonly EPage: typeof EPage = EPage;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly RelationType: typeof ERelationType = ERelationType;

  constructor() {
    this.shoppingCartService.productForms.updateValueAndValidity();
    effect((): void => {
      this.shoppingCartService.loadTicketConfiguration(this.ticketName());
    });

    effect(() => {
      this.directTicketOrderService.setCurrentProductDefinition();
    });

    effect(() => {
      this.directTicketOrderService.tryToAddToCart();
    });
  }

  protected proceedToPersonalData(): void {
    this.router.navigate([
      `/${ERoute.directTicketConfiguration}/${ERoute.personalData}/`,
    ]);
  }
}
